import React from 'react';
import { observer } from 'mobx-react';
import { VOTE_OPEN, VOTE_CLOSED, VOTE_DRAFT, VOTE_VIEW_LIST } from '../../../helpers/constants';
import store from '../../../stores/store';
import _ from 'lodash';
import VoteCard from './VoteCard';

const VotePanel = observer(
    class VotePanel extends React.Component {
        constructor() {
            super();

            this.state = {
                filter: VOTE_OPEN,
            };
        }

        setFilter = filter => {
            this.setState({ filter: filter });
        };

        renderHeader = () => {
            const openVotes = store.votes.filterVotesByCurrentHierarchyAndFilter(VOTE_OPEN);
            const newVoteCount = store.votes.newVoteCount();
            return (
                <div className="row align-items-center mb-3">
                    <div className="col ml-3">
                        <h6>Votes</h6>
                    </div>
                    <div
                        className="col-auto"
                        data-toggle="buttons"
                        role="group"
                        aria-label="Votes"
                        id="attendee-btn-grp"
                    >
                        <div className="btn-group pl-3 mr-3" role="tablist">
                            {openVotes.length === 0 ? null : (
                                <a
                                    className={`btn btn-outline-secondary ${this.state.filter ===
                                        VOTE_OPEN
                                        ? 'active'
                                        : ''}`}
                                    data-toggle="tab"
                                    role="tab"
                                    onClick={() => this.setFilter(VOTE_OPEN)}
                                >
                                    Open
                                    {newVoteCount > 0 ? (
                                        <span className="badge badge-pill badge-notify">
                                            {newVoteCount}
                                        </span>
                                    ) : null}
                                </a>
                            )}
                            {store.votes.filterVotesByCurrentHierarchyAndFilter(VOTE_CLOSED)
                                .length === 0 ? null : (
                                    <a
                                        className={`btn btn-outline-secondary ${this.state.filter ===
                                            VOTE_CLOSED
                                            ? 'active'
                                            : ''}`}
                                        data-toggle="tab"
                                        role="tab"
                                        onClick={() => this.setFilter(VOTE_CLOSED)}
                                    >
                                        Closed
                                </a>
                                )}
                            {store.votes.filterVotesByCurrentHierarchyAndFilter(VOTE_DRAFT)
                                .length === 0 ? null : (
                                    <a
                                        className={`btn btn-outline-secondary ${this.state.filter ===
                                            VOTE_DRAFT
                                            ? 'active'
                                            : ''}`}
                                        data-toggle="tab"
                                        role="tab"
                                        onClick={() => this.setFilter(VOTE_DRAFT)}
                                    >
                                        Draft
                                </a>
                                )}
                        </div>
                    </div>
                </div>
            );
        };

        getLogo = instanceId => {
            const coIndex = store.companies.indexFromId(instanceId);
            if (typeof store.companies.logos[coIndex] !== 'undefined') {
                const logo =
                    store.companies.logos.length > 0 ? store.companies.logos[coIndex].url : '';
                return logo;
            }
            return '';
        };

        getGroupName = vote => {
            const companyIndex = store.companies.indexFromId(vote.InstanceId);
            const groups = _.get(this.data, `companies.groups.${companyIndex}`, null);
            if (groups !== null) {
                groups.filter((group, i) => {
                    return group.GroupId === vote.GroupId;
                });
            }

            return null;
        };

        sortVotes = votes => {
            switch (this.state.filter) {
                case VOTE_OPEN:
                    votes.sort(function (a, b) {
                        return a.VotePublishedDate.localeCompare(b.VotePublishedDate);
                    });
                    break;
                case VOTE_CLOSED:
                    votes.sort(function (a, b) {
                        return b.VotePublishedDate.localeCompare(a.VotePublishedDate);
                    });
                    break;
                case VOTE_DRAFT:
                    votes.sort(function (a, b) {
                        return a.VoteCreated.localeCompare(b.VoteCreated);
                    });
                    break;
                default:
                    return null;
            }
        };

        componentDidMount() {
            this.toggleIfNoContent();
        }
        componentWillReceiveProps(nextProps) {
            this.toggleIfNoContent();
        }

        toggleIfNoContent() {
            // console.log("toggleIfNoContent", this.state.filter);

            const filteredOpenVotes = store.votes.filterVotesByCurrentHierarchyAndFilter(VOTE_OPEN);
            const filteredClosedVotes = store.votes.filterVotesByCurrentHierarchyAndFilter(
                VOTE_CLOSED,
            );
            const filteredDraftVotes = store.votes.filterVotesByCurrentHierarchyAndFilter(
                VOTE_DRAFT,
            );

            //only move the filter option if that filter is now empty
            switch (this.state.filter) {
                case VOTE_OPEN:
                    if (filteredOpenVotes.length === 0) {
                        if (filteredClosedVotes.length !== 0) {
                            this.setFilter(VOTE_CLOSED);
                        } else if (filteredDraftVotes.length !== 0) {
                            this.setFilter(VOTE_DRAFT);
                        }
                    }
                    break;

                case VOTE_CLOSED:
                    if (filteredClosedVotes.length === 0) {
                        if (filteredOpenVotes.length !== 0) {
                            this.setFilter(VOTE_OPEN);
                        } else if (filteredDraftVotes.length !== 0) {
                            this.setFilter(VOTE_DRAFT);
                        }
                    }
                    break;

                case VOTE_DRAFT:
                    if (filteredDraftVotes.length === 0) {
                        if (filteredOpenVotes.length !== 0) {
                            this.setFilter(VOTE_OPEN);
                        } else if (filteredClosedVotes.length !== 0) {
                            this.setFilter(VOTE_CLOSED);
                        }
                    }
                    break;
                default:
                    this.setFilter(VOTE_OPEN);
            }
        }

        isDataReady = filteredVotes => {
            let readyOrNot = false;
            filteredVotes.forEach((vote, index) => {
                const companyIndex = store.companies.indexFromId(vote.InstanceId);
                if (
                    index === filteredVotes.length - 1 &&
                    store.companies.groups[companyIndex] !== undefined
                ) {
                    readyOrNot = true;
                }
            });

            return readyOrNot;
        };

        selectVote(instanceId, groupId, voteId, history) {
            store.votes.select(voteId);
            //local.setVoteAsRead(instanceId, groupId, voteId, utils.getNowInUtc());

            if (store.groups.selectedId === null) {
                const index = store.companies.indexFromId(instanceId);
                store.groups.toggleSelected(groupId, index);
            }

            //now redirect
            history.push('/dashboard/vote/votedetails');
        }

        render() {
            let filteredVotes = store.votes.filterVotesByCurrentHierarchyAndFilter(
                this.state.filter,
            );
            let loading = store.votes.loading;

            if (loading || !this.isDataReady(filteredVotes)) {
                return null;
            }
            this.sortVotes(filteredVotes);

            return (
                <div>
                    {this.renderHeader()}
                    <div className="tab-content d-flex" id="votes-list">
                        <div className="tab-pane w-100 active" id="vote-open" role="tabpanel">
                            <div className="row">
                                {filteredVotes.map((filteredVote, index) => {
                                    return (
                                        <VoteCard
                                            detail={filteredVote}
                                            key={index}
                                            logo={this.getLogo(filteredVote.InstanceId)}
                                            groupName={this.getGroupName(filteredVote)}
                                            instanceId={filteredVote.InstanceId}
                                            selectVote={this.selectVote}
                                            viewType={VOTE_VIEW_LIST}
                                            history={this.props.history}
                                        />
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
    },
);

export default VotePanel;



// WEBPACK FOOTER //
// ./src/containers/PrivateArea/Vote/VotePanel.js